//import Vue from 'vue';
//import Vuex from 'vuex';
import { createStore } from 'vuex';

// import { UserState } from './entityModule/user/userModule';
//Vue.use(Vuex);

//export default new Vuex.Store({
export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  },
});

//xport interface RootState {
  // userState: UserState;
//}

//export default new Vuex.Store<RootState>({});
